module.exports = __webpack_public_path__ + "img/Nora/Nora-ms-icon-144x144.png";